export default __webpack_public_path__ + "static/generationen-clip-2-3b678b86f4d57c413bb9b150da1249da.mp4";